import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import { format, parseISO } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'
// import Pagination from "../CommonUI/Pagination/Pagination"
function MfDividend() {
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    const [CategoryDividend, setCategoryDividend] = useState('5946');
    const [ShemeDividend, setShemeDividend] = useState('26');
    const [ShemeCodeDividend, setShemeCodeDividend] = useState('-');
    const [DataMfHoldingdropFundDivi, setDataMfHoldingdropFundDivi] = useState([]);
    const [DataMfHoldingdropCatDivi, setDataMfHoldingdropCatDivi] = useState([]);
    const [DataMfHoldingdropShemeDivi, setDataMfHoldingdropShemeDivi] = useState([]);
    const [DataMfHoldingDividend, setDataMfHoldingDividend] = useState([]);
    const [valuebtn, setValueBtn] = useState("-");
    const [DateDividend, setDateDividend] = useState("-");
    const [DateDividenddrop,setDateDividenddrop] = useState([]);
    let navigate = useNavigate();
    const [valueschemename, setValueschemename] = useState([]);
    const [valuecategory, setValuecategory] = useState([]);
    const [valuecode,setvaluecode] = useState([]);
    const [valuecodehist,setvaluecodehist] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    
    // const [DateDividend, setDataMfHoldingdropDate] = useState("-");
    let getDataHoldingdropFundDivi, getDataHoldingdropCatDivi,
         getDataHoldingDividend,getDataHoldingdropDate;
    let PageSize = 5;
    useEffect(() => {
        setloadingshow(true);
        const getUrlMfTopHoldingDividend = BaseURL + "MfDividend";
        fetch(`${getUrlMfTopHoldingDividend}/${DateDividend}/-/${ShemeDividend}/${CategoryDividend}/-/8/-`)
            .then((response) => response.json())
            .then((dataMHoldingdDivided) => {
                getDataHoldingDividend = dataMHoldingdDivided.data;
                setDataMfHoldingDividend(getDataHoldingDividend);
                setloadingshow(false);
                // console.log(getDataHoldingDividend, "MfDividend")
            })
            .catch((error) => {
            });
        const getUrlMfTopHoldingDropDividend = BaseURL + "MfHoldingDrop";

        fetch(`${getUrlMfTopHoldingDropDividend}/-/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropFund) => {
                getDataHoldingdropFundDivi = dataMHoldingdropFund.data;
                setDataMfHoldingdropFundDivi(getDataHoldingdropFundDivi);
                var codename = getDataHoldingdropFundDivi[0].co_name;
                setValueschemename(codename)
                // console.log(getDataHoldingdropFundDivi, "getDataHoldingdropFundDivi")
            })
            .catch((error) => {
            });
        fetch(`${getUrlMfTopHoldingDropDividend}/${CategoryDividend}/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropCat) => {
                getDataHoldingdropCatDivi = dataMHoldingdropCat.data;
                setDataMfHoldingdropCatDivi(getDataHoldingdropCatDivi);
                var categoryname = getDataHoldingdropCatDivi[0].VCLASS;
                setValuecategory(categoryname)
                // console.log(getDataHoldingdropCatDivi, "getDataHoldingdropCatDivi")
            })
            .catch((error) => {
            });

            const getUrlMfTopHoldingDate = BaseURL + "MfDateDividend";

            fetch(`${getUrlMfTopHoldingDate}`)
                .then((response) => response.json())
                .then((dataMHoldingdropDate) => {
                    getDataHoldingdropDate = dataMHoldingdropDate.data;
                    setDateDividenddrop(getDataHoldingdropDate);
                    setloadingshow(false);
                    // console.log(getDataHoldingdropDate, "getDataHoldingdropDate")
                })
                .catch((error) => {
                });

    }, [CategoryDividend, ShemeDividend, ShemeCodeDividend, valuebtn,DateDividend])

    const currentTableData = useMemo(() => {
        if (DataMfHoldingDividend != null && DataMfHoldingDividend != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (DataMfHoldingDividend != null && DataMfHoldingDividend != []) {
                if (DataMfHoldingDividend.length > 0) {
                    return DataMfHoldingDividend.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, DataMfHoldingDividend]);


    return (
        <>
            <div className='market-inner-common market-mf-main'>
                <div className='market-header'>
                    <h4>Dividend</h4>
                    <span className="moreContent" onClick={()=>{navigate("/MutualFund/Dividend-Details")}}>See More</span>
                </div>
                <Container className="add-border table-box">
                <div className='mf-common dividend'>
                    <div id="divDividendDrop">
                        <div className='holdings-select'>

                            {/* aria-label="Select Fund House" */}
                            <select aria-label="Select Fund House" onChange={(event) => setCategoryDividend(event.target.value)}>
                                <option>Select Fund House</option>
                                {DataMfHoldingdropFundDivi && DataMfHoldingdropFundDivi.map(
                                    ({ mf_cocode, co_name }) => (
                                        <option value={mf_cocode}  selected={valueschemename === co_name}>{co_name}</option>
                                    )
                                )}
                            </select>
                        </div>
                        <div className='holdings-select'>
                                {/* aria-label="Select Category" */}
                            <select aria-label="Select Category" onChange={(event) => setShemeDividend(event.target.value)}>
                                <option>Select Category</option>
                                {DataMfHoldingdropCatDivi && DataMfHoldingdropCatDivi.map(
                                    ({ VCLASSCODE, VCLASS }) => (
                                        <option value={VCLASSCODE} selected={valuecategory === VCLASS} >{VCLASS}</option>
                                    )
                                )}
                            </select>
                        </div>

                        <div className='holdings-select'>
                            {/* aria-label="Select Date"    */}
                            <select aria-label="Select Date" onChange={(event) => setDateDividend(event.target.value)}>
                                <option>Select Date</option>
                                {DateDividenddrop && DateDividenddrop.map(
                                    ({ DivDate}) => (
                                        <option value={DivDate}>{DivDate}</option>
                                    )
                                )}
                            </select>
                        </div>  
                    </div>

                    {/* update tabIndex={0} */}
                    <div className='mf-table table-responsive gainer-table' tabIndex={0}>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th className='text-left'>Company Name</th>
                                    <th className='text-right'>Nav(&#8377;)</th>
                                    <th className='text-left'>Dividend(%)</th>
                                    <th className='text-left'>Record Date</th>
                                    <th className='text-left'>1 Year(%)</th>
                                    <th className='text-left'>3 Year(%)</th>
                                </tr>
                            </thead>
                            {(DataMfHoldingDividend === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                            <tbody>
                                {(DataMfHoldingDividend != null) && DataMfHoldingDividend.map(
                                    ({ MF_SCHCODE, Sch_Name,NAVRS,DivAmount,RecordDate,year1,year3}) => (
                                        <tr>
                                            <td className='text-left'>{Sch_Name}</td>
                                            <td className='text-right'>{NAVRS.toFixed(2)}</td>
                                            <td className='text-right'>{(DivAmount.toFixed(2) != null) ? DivAmount.toFixed(2) : 0}</td>
                                            <td className='text-right'>{format(parseISO(RecordDate.split('T')[0] != null ? RecordDate.split('T')[0] :0), 'dd-MMM-yyyy') }</td>
                                            <td className='text-right text-green'>{(year1 != null) ? year1.toFixed(2) : 0}</td>
                                            <td className='text-right text-green'>{(year3 != null) ? year3.toFixed(2) : 0}</td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                        {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                    </div>
                    {/* {(DataMfHoldingDividend != null && DataMfHoldingDividend != []) ?
                            <Pagination
                                className="pagination-bar_peer"
                                currentPage={currentPage}
                                totalCount={(DataMfHoldingDividend.length != null) ? DataMfHoldingDividend.length : 0}
                                pageSize={PageSize}
                                onPageChange={page => setCurrentPage(page)}
                            /> : <p className="errorPeer"> No Data Found !!! </p>} */}
                </div>
                </Container>
            </div>
        </>
    )
}

export default MfDividend